import type {
  AnalyticsService,
  AnalyticsServiceEvent,
  AnalyticsServicePage,
} from '@application/AnalyticsService';
import type {
  AnonymousUser,
  Group,
  UserInformation,
  UserInformationService,
} from '@application/UserInformationService';

interface SimpleLoggingService {
  log: (msg: string) => void;
}

export class FakeAnalyticsService
  implements AnalyticsService, UserInformationService
{
  private loggingService: SimpleLoggingService;

  constructor(loggingService: SimpleLoggingService) {
    this.loggingService = loggingService;
  }

  logPage = (page: AnalyticsServicePage) => {
    this.loggingService.log(
      `Tracking page visit: "${page.name}", payload: ${JSON.stringify(
        page.payload,
      )}`,
    );
  };

  logEvent = (event: AnalyticsServiceEvent) => {
    this.loggingService.log(
      `Tracking event: "${event.name}", payload: ${JSON.stringify(
        event.payload,
      )}, url: ${event.url?.toString()}`,
    );
  };

  setUserInformation = (user: UserInformation | AnonymousUser) => {
    if (user) {
      return this.loggingService.log(
        `Setting user information: ${JSON.stringify(user)}`,
      );
    }
    this.loggingService.log('User is anonymous');
  };

  setGroup = (group: Group | null) => {
    this.loggingService.log(
      `Setting group information: ${JSON.stringify(group)}`,
    );
  };
}
